import { Component, createEffect, createSignal, JSX, Show } from 'solid-js';
import { cn } from '~/utils/classnames';

type ImageWithFallbackProps = JSX.ImgHTMLAttributes<HTMLImageElement> & {
  alt?: string;
  class?: string;
  src?: string;
  fallback: string | JSX.Element;
};

const ImageWithFallback: Component<ImageWithFallbackProps> = (props) => {
  const [error, setError] = createSignal(false);

  createEffect(() => {
    setError(props.src === undefined);
  });

  const handleError = () => {
    console.log('Image failed to load:', props.src, props.alt);
    setError(true);
  };

  return (
    <Show
      when={!error() && props.src}
      fallback={
        typeof props.fallback === 'string' ? (
          <img src={props.fallback} alt={props.alt || ''} class={cn('object-cover', props.class)} />
        ) : (
          props.fallback
        )
      }>
      <img src={props.src} alt={props.alt || ''} class={cn('object-cover', props.class)} onError={handleError} />
    </Show>
  );
};

export default ImageWithFallback;
